import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner'; // Ejemplo con PrimeNG

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [ProgressSpinnerModule],
  template: `
    <div class="global-loader-overlay">
      <p-progressSpinner
        strokeWidth="4"
        animationDuration=".5s"
      ></p-progressSpinner>
      <p>Loading, please wait</p>
    </div>
  `,
  styles: [
    `
      .global-loader-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.9);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 9999;
      }
      .global-loader-overlay p {
        margin-top: 10px;
        font-size: 1.2em;
      }
    `,
  ],
})
export class GlobalLoaderComponent {}
